<template>
    <div class="flex flex-col">
        <div
            class="select-none items-center whitespace-nowrap border-t border-gray-350 bg-white pt-4 text-left text-[15px] font-semibold !text-gray-800 lg:hidden"
        >
            Your Students
        </div>
        <div
            class="mb-2 flex flex-col pt-4 lg:flex-row lg:justify-between"
        >
            <div class="w-full lg:order-last lg:w-1/4">
                <form-search
                    v-model="filters.search"
                    placeholder="Search for student by name"
                />
            </div>
            <div
                class="box-content flex h-10 items-center rounded border border-gray-350 text-center text-[15px]"
            >
                <label
                    :class="
                        'flex h-10 flex-grow items-center justify-center border-r border-gray-350 px-4 py-2 hover:cursor-pointer hover:bg-gray-250' +
                        ' ' +
                        (filters.status === 'active'
                            ? 'bg-gray-250 font-medium'
                            : 'bg-white text-gray-650')
                    "
                ><input
                    class="hidden"
                    type="radio"
                    name="status[]"
                    v-model="filters.status"
                    value="active"
                />Active ({{
                        $page.props.classroom.active_students_count
                    }})</label
                >
                <label
                    :class="
                        'flex h-10 flex-grow items-center justify-center border-r border-gray-350 px-4 py-2 hover:cursor-pointer hover:bg-gray-250' +
                        ' ' +
                        (filters.status === 'pending'
                            ? 'bg-gray-250 font-medium'
                            : 'bg-white text-gray-650')
                    "
                ><input
                    class="hidden"
                    type="radio"
                    name="status[]"
                    v-model="filters.status"
                    value="pending"
                />Pending ({{
                        $page.props.classroom.pending_students_count
                    }})</label
                >
                <label
                    :class="
                        'flex h-10 flex-grow items-center justify-center px-4 py-2 hover:cursor-pointer hover:bg-gray-250' +
                        ' ' +
                        (filters.status === 'expired'
                            ? 'bg-gray-250 font-medium'
                            : 'bg-white text-gray-650')
                    "
                ><input
                    class="hidden"
                    type="radio"
                    name="status[]"
                    v-model="filters.status"
                    value="expired"
                />Expired ({{
                        $page.props.classroom.expired_students_count
                    }})</label
                >
            </div>
        </div>

        <easy-data-table
            class="mobile-table student-overview table"
            v-model:server-options="serverOptions"
            :server-items-length="$page.props.students.total"
            :loading="loading"
            :headers="headers"
            :items="$page.props.students.data"
            :hide-footer="hideFooter"
            :rows-per-page="10"
            :rows-items="[10, 25, 50]"
            buttons-pagination
            must-sort
            :empty-message="emptyMessage"
        >
            <template #item-full_name="student">
                <Link
                    class="group hover:cursor-pointer hover:text-blue-500"
                    :href="
                        route('group.student.show', {
                            user: student.id,
                        })
                    "
                >
                    <div class="flex items-center gap-2 whitespace-nowrap">
                        <span class="hidden lg:inline">
                            <UserAvatarRound :user="student" size="28"/>
                        </span>
                        <span
                            class="font-semibold group-hover:underline md:font-medium"
                        >
                            <span
                                v-if="
                                    student.subscription.status !== 'incomplete'
                                "
                            >
                                {{ student.full_name }}</span
                            >
                            <span v-else> {{ student.email }}</span>
                        </span>
                    </div>
                </Link>
            </template>

            <template #item-provider_level.id="student">
                <ProviderLevelLabel
                    :providerLevelTitle="student.provider_level.title"
                />
            </template>

            <template #item-time_spent_studying="student">
                <div class="mobile-blue-linebreak text-gray-750">
                    <span>{{ student.time_spent_studying_readable }}</span>
                    <div class="linebreak"></div>
                </div>
            </template>

            <template #item-scores="student">
                <div class="flex flex-wrap gap-2" v-if="student.performance">
                    <template
                        v-for="focusArea in student.performance
                            .focus_area_scores"
                    >
                        <Tooltip
                            :width-px="320"
                            css-classes="border-gray-200 bg-white p-4 drop-shadow-md md:w-[300px] xl:w-[420px]"
                        >
                            <template #trigger>
                                <focus-area-score-round-label
                                    :score="focusArea.avg"
                                />
                            </template>
                            <template #content>
                                <div class="">
                                    <div
                                        class="mb-4 border-b border-gray-400 pb-1 font-semibold"
                                    >
                                        <span
                                            class="border-b-3 border-blue-300 pb-1"
                                        >
                                            {{
                                                getFocusArea(focusArea.fa_id)
                                                    .title
                                            }}
                                        </span>
                                    </div>

                                    <div
                                        class="flex flex-col gap-2 xl:flex-row xl:gap-4"
                                    >
                                        <div class="">
                                            <!--                                            <div-->
                                            <!--                                                class="h-4 font-[13px] font-semibold text-gray-650"-->
                                            <!--                                            >-->
                                            <!--                                                <span> </span>-->
                                            <!--                                                <Tooltip :width-px="240">-->
                                            <!--                                                    <template #trigger>-->
                                            <!--                                                        <span-->
                                            <!--                                                            class="underline decoration-dotted hover:text-blue-300"-->
                                            <!--                                                        >-->
                                            <!--                                                            Last 100 Attempts-->
                                            <!--                                                        </span>-->
                                            <!--                                                    </template>-->
                                            <!--                                                    <template #content>-->
                                            <!--                                                        <div class="">-->
                                            <!--                                                            <div-->
                                            <!--                                                                class="mb-2 font-semibold"-->
                                            <!--                                                            >-->
                                            <!--                                                                In the last 5-->
                                            <!--                                                                Active Days-->
                                            <!--                                                            </div>-->
                                            <!--                                                            <div-->
                                            <!--                                                                class="text-[13px] text-gray-450"-->
                                            <!--                                                            >-->
                                            <!--                                                                An “active day”-->
                                            <!--                                                                is one in which-->
                                            <!--                                                                a student has-->
                                            <!--                                                                answered at-->
                                            <!--                                                                least 1 question-->
                                            <!--                                                                in this-->
                                            <!--                                                                category.-->
                                            <!--                                                            </div>-->
                                            <!--                                                        </div>-->
                                            <!--                                                    </template>-->
                                            <!--                                                </Tooltip>-->
                                            <!--                                            </div>-->
                                            <div
                                                class="h-4 font-[13px] font-semibold text-gray-650"
                                            >
                                                Last 100 Attempts
                                            </div>
                                            <div class="mt-1">
                                                <span class="font-semibold">
                                                    {{ focusArea.q_correct }}/{{
                                                        focusArea.q_total
                                                    }}
                                                </span>
                                                correct
                                            </div>
                                        </div>
                                        <div class="">
                                            <div
                                                class="h-4 font-[13px] font-semibold text-gray-650"
                                            >
                                                All-Time Attempts
                                            </div>
                                            <div class="mt-1">
                                                <span class="font-semibold">
                                                    {{
                                                        student.performance
                                                            .lifetime_focus_area_question_counts[
                                                        "fa_id_" +
                                                        focusArea.fa_id
                                                            ]
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Tooltip>
                    </template>
                </div>
                <div v-else class="flex flex-wrap gap-2">
                    <div
                        v-for="index in 5"
                        :key="index"
                        class="flex h-10 w-12 items-center justify-center whitespace-nowrap rounded rounded-full bg-gray-100 px-4 font-medium"
                    >
                        --%
                    </div>
                </div>
            </template>

            <template #item-classroom_goals="student">
                <div class="flex items-center justify-start gap-2">
                    <template v-for="(goal, index) in classroom.goals">
                        <div
                            v-if="goal.enabled"
                            :class="
                                'text-medium flex h-10 w-10 items-center justify-center rounded rounded-full text-[15px]' +
                                ' ' +
                                (student.classroom_goals[index].completed
                                    ? 'bg-blue-300 text-white'
                                    : 'bg-gray-250 text-gray-850')
                            "
                        >
                            {{ goal.label }}
                        </div>
                    </template>
                </div>
            </template>

            <template #item-actions="student">
                <dropdown open-from="right" :px-width="260">
                    <template #button>
                        <more-dots-button/>
                    </template>
                    <template #content>
                        <ul class="rounded border">
                            <li>
                                <Link
                                    class="link block p-4"
                                    :href="
                                        route('group.student.show', {
                                            user: student.id,
                                        })
                                    "
                                >Edit Student
                                </Link>
                            </li>
                            <li
                                v-if="
                                    $page.props.auth.user
                                        .group_admin_permission_level !==
                                    'read-only'
                                "
                            >
                                <GroupRemoveStudentButton :student="student"/>
                            </li>
                            <li v-if="student.subscription.is_pending">
                                <Link
                                    as="div"
                                    :href="
                                        route('group.student.resend-invite', {
                                            user: student.id,
                                        })
                                    "
                                    class="px-4 py-2 hover:cursor-pointer hover:bg-gray-200"
                                >Resend invite
                                </Link>
                            </li>
                            <li v-if="student.subscription.is_pending">
                                <GroupRevokeStudentInviteButton
                                    :student="student"
                                />
                            </li>
                        </ul>
                    </template>
                </dropdown>
            </template>
        </easy-data-table>
    </div>
</template>
<script>
import Dropdown from "@/Components/Dropdown";
import MoreDotsButton from "@/Components/MoreDotsButton";
import ProviderLevelLabel from "@/Components/ProviderLevelLabel";
import FormSearch from "@/Components/FormSearch";
import FocusAreaScoreRoundLabel from "@/Components/FocusAreaScoreRoundLabel";
import Tooltip from "@/Components/Tooltip";
import UserAvatarRound from "@/Components/UserAvatarRound";
import GroupRemoveStudentButton from "@/Components/GroupRemoveStudentButton.vue";
import GroupRevokeStudentInviteButton from "@/Components/GroupRevokeStudentInviteButton.vue";

export default {
    name: "GroupClassroomStudentsOverview",
    components: {
        GroupRevokeStudentInviteButton,
        GroupRemoveStudentButton,
        UserAvatarRound,
        Tooltip,
        FocusAreaScoreRoundLabel,
        ProviderLevelLabel,
        Dropdown,
        MoreDotsButton,
        FormSearch,
    },
    props: {
        classroom: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            filters: this.$inertia.form({
                status: this.$page.props.currentFilters.status,
                search: this.$page.props.currentFilters.search,
            }),
            serverOptions: {
                page: this.$page.props.students.current_page,
                rowsPerPage: this.$page.props.students.per_page,
                sortBy: "full_name",
                sortType: "desc",
            },
            serverItemsLength: this.$page.props.students.total,
            loading: false,
            hideFooter: !(
                this.$page.props.students &&
                this.$page.props.students.total > 10
            ),
            headers: [
                {
                    text: "Student",
                    value: "full_name",
                    sortable: true,
                },
                {
                    text: "Level",
                    value: "provider_level.id",
                    sortable: true,
                },
                {
                    text: "Study Time",
                    value: "time_spent_studying",
                    sortable: true,
                },
                {
                    text: "Scores",
                    value: "scores",
                    sortable: true,
                },
                {
                    text: "Goals",
                    value: "classroom_goals",
                    width: 100,
                },
                {
                    text: "",
                    value: "actions",
                    width: 30,
                },
            ],
            emptyMessage: "0 students found",
        };
    },
    methods: {
        updateFilters() {
            let vm = this;

            this.$inertia.get(
                route("group.classroom.show", {classroom: this.classroom.id}),
                {
                    sortBy: this.serverOptions.sortBy,
                    sortType: this.serverOptions.sortType,
                    status: this.filters.status,
                    search: this.filters.search,
                    page: this.serverOptions.page,
                    perPage: this.serverOptions.rowsPerPage,
                },
                {
                    preserveState: true,
                    preserveScroll: true,
                    replace: true,
                    only: [
                        "classroom",
                        "students",
                        "currentFilters",
                        "serverOptions",
                    ],
                    onStart: function () {
                        vm.loading = true;
                    },
                    onFinish: function () {
                        vm.hideFooter =
                            vm.$page.props.students &&
                            vm.$page.props.students.total < 10;

                        vm.loading = false;
                    },
                }
            );
        },
        getFocusArea(focusAreaId) {
            let focusArea = _.find(
                this.$page.props.focusAreas,
                function (focusArea) {
                    return focusArea.id === focusAreaId;
                }
            );

            return focusArea;
        },
    },
    watch: {
        filters: {
            handler: _.debounce(function (newValue, oldValue) {
                this.serverOptions.page = 1;
                this.updateFilters();
            }, 250),
            deep: true,
        },
        serverOptions: {
            handler: _.debounce(function (newValue, oldValue) {
                this.updateFilters();
            }, 100),
            deep: true,
        },
    },
};
</script>
